import React from "react";
import { Cell, Column } from "react-table";
import { Check as Yes, X as No } from "react-feather";

import nameof from "../../common/helpers/nameof";
import TextFilter from "../../common/components/ReactTable/Components/Filtering/TextFilter";
import MultiSelectFilter from "../../common/components/ReactTable/Components/Filtering/MultiSelectFilter";

import { AttendeeWithFeedback } from "./types/types";

const iconSize = 16;

interface AnswerIconProps {
  value: boolean;
}

const AnswerIcon: React.FC<AnswerIconProps> = ({ value }) => value
  ? (
    <span className="text-success">
      <Yes size={iconSize} />
    </span>)
  : (
    <span className="text-danger">
      <No size={iconSize} />
    </span>);

const getColumns: (
  isFiltered: boolean,
  anyQuestions: boolean,
  questionIndex: string) => Column<AttendeeWithFeedback>[] = (isFiltered, anyQuestions, questionIndex) => [{
    Header: "Name",
    Footer: "Name",
    Filter: isFiltered ? void 0 : TextFilter,
    disableSortBy: isFiltered,
    accessor: nameof<AttendeeWithFeedback>("name"),
  }, {
    Header: "Company",
    Footer: "Company",
    Filter: isFiltered ? void 0 : TextFilter,
    disableSortBy: isFiltered,
    accessor: nameof<AttendeeWithFeedback>("company"),
  }, {
    Header: "FCA Number",
    Footer: "FCA Number",
    Filter: isFiltered ? void 0 : TextFilter,
    disableSortBy: isFiltered,
    accessor: nameof<AttendeeWithFeedback>("fcaNumber"),
  }, {
    Header: "Email",
    Footer: "Email",
    Filter: isFiltered ? void 0 : TextFilter,
    disableSortBy: isFiltered,
    accessor: nameof<AttendeeWithFeedback>("email"),
  }, {
    Header: "Postcode",
    Footer: "Postcode",
    disableSortBy: isFiltered,
    accessor: attendee => attendee.address?.postCode,
  }, {
    Header: "Score",
    Footer: "Score",
    disableSortBy: isFiltered,
    accessor: attendee => attendee.scores?.overall,
  },
  ...(anyQuestions ? [{
    Header: "Answer",
    Footer: "Answer",
    filter: "multiSelect",
    Filter: isFiltered ? void 0 : MultiSelectFilter,
    disableSortBy: isFiltered,
    accessor: nameof<AttendeeWithFeedback>("answer"),
    Cell: ({ value }: Cell<AttendeeWithFeedback, string>) => !!value
      ? (<AnswerIcon value={value === "Yes"} />)
      : null,
  } as Column<AttendeeWithFeedback>] : [])];

export default getColumns;
